import React from 'react';
import CreditCardFormSection from './CreditCardFormSection';
import OwnershipCarType from '../../../../../types/ownershipCar.type';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import InputTextArea from '../../../../../components/form/InputTextArea';
import InputGroup from '../../../../../components/form/InputGroup';
import Alert from '../../../../../components/Alerts/Alert';
import { AlertColors } from '../../../../../enums/alertColors.types';
import { useModalRenewedPermitData } from '../../../../../stores/renewedPermitModal.store';
import useRenewedPermitModalFunctions from '../../../../../hooks/useRenewedPermitModalFunctions';
import renewedPermitModalLang from '../../../../../data/lang/homePage/renewedPermitModal.lang';
import { useTags } from '../../../../../hooks/useTags';



const RenewedPermitForm = () => {

    const { handleBlurRenewedPermitInput,
        handleSetRenewedPermitFormFile,
        handleSetRenewedPermitFormStr
    } = useRenewedPermitModalFunctions();
    const renewedPermitData = useModalRenewedPermitData();
    const { endValidityDate, permitId, renewedPermitStep, form, isCompany: isCompanyInt } = renewedPermitData;
    const { values, errors, touched } = form;

    const generateTag = useTags();
    const commentLabel = generateTag(renewedPermitModalLang, 'form.comment-label');

    const ownershipCarLabel = generateTag(renewedPermitModalLang, 'form.ownership-car-label');
    const privateCarLabel = generateTag(renewedPermitModalLang, 'form.private-car-label');
    const companyCarLabel = generateTag(renewedPermitModalLang, 'form.company-car-label');
    const scanPersonIdLabel = generateTag(renewedPermitModalLang, 'form.scan-person-id-label');
    const scanCarIdLabel = generateTag(renewedPermitModalLang, 'form.scan-car-id-label');
    const scanWorkStatementLabel = generateTag(renewedPermitModalLang, 'form.scan-work-statement-label');
    const declerationTitleTag = generateTag(renewedPermitModalLang, 'form.declaration-title');
    const declerationBodyTag = generateTag(renewedPermitModalLang, 'form.declaration-body');

    const isCompany = isCompanyInt === OwnershipCarType.COMPANY;

    if (renewedPermitStep !== 'form') {
        return null;
    }

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-12 col-sm-6'>

                    <RadioBtnsContainer label={ownershipCarLabel}>
                        <RadioOutlineBtn
                            isChecked={!isCompany}
                            label={privateCarLabel}
                            value={OwnershipCarType.PRIVATE}
                            //onClick={handleClick}
                            id="isCompanyYes"
                            name='isCompany'
                            disabled
                        />
                        <RadioOutlineBtn
                            isChecked={isCompany}
                            label={companyCarLabel}
                            value={OwnershipCarType.COMPANY}
                            //onClick={handleClick}
                            id="isCompanyNo"
                            name='isCompany'
                            disabled
                        />
                    </RadioBtnsContainer>
                </div>
            </div>

            <div className='row mb-2'>
                <div className='col-12'>
                    <InputTextArea
                        handleBlur={handleBlurRenewedPermitInput}
                        handleChange={handleSetRenewedPermitFormStr}
                        value={values.citizenComment}
                        name='citizenComment'
                        label={commentLabel}
                        required={false}
                        errorMsg={(errors.citizenComment && touched.citizenComment) ? errors.citizenComment : undefined}
                    />
                </div>
            </div>

            <div className='row mb-4'>
                <div className='col-12'>
                    <InputGroup
                        isRequired
                        label={scanPersonIdLabel}
                        handleChange={handleSetRenewedPermitFormFile}
                        handleBlur={handleBlurRenewedPermitInput}
                        type='file'
                        name='scanPersonId'
                        //@ts-ignore
                        errorMsg={(errors.scanPersonId && touched.scanPersonId) ? errors.scanPersonId : undefined}
                    />
                </div>
                <div className='col-12'>
                    <InputGroup
                        isRequired
                        label={scanCarIdLabel}
                        handleChange={handleSetRenewedPermitFormFile}
                        handleBlur={handleBlurRenewedPermitInput}
                        type='file'
                        name='scanCarId'
                        //@ts-ignore
                        errorMsg={(errors.scanCarId && touched.scanCarId) ? errors.scanCarId : undefined}
                    />
                </div>
                {isCompany && (
                    <div className='col-12'>
                        <InputGroup
                            isRequired
                            label={scanWorkStatementLabel}
                            handleChange={handleSetRenewedPermitFormFile}
                            handleBlur={handleBlurRenewedPermitInput}
                            type='file'
                            name='scanWorkStatment'
                            //@ts-ignore
                            errorMsg={(errors.scanWorkStatment && touched.scanWorkStatment) ? errors.scanWorkStatment : undefined}
                        />
                    </div>
                )}

            </div>

            <CreditCardFormSection />

            <div className='row'>
                <div className='col-12'>
                    <Alert isShow
                        subject={declerationTitleTag}
                        message={declerationBodyTag}
                        type={AlertColors.INFO} />
                </div>
            </div>
        </div>
    );

}

export default RenewedPermitForm;